import { render } from "./InputGroup.vue?vue&type=template&id=560000ef&scoped=true&ts=true"
import script from "./InputGroup.vue?vue&type=script&lang=ts"
export * from "./InputGroup.vue?vue&type=script&lang=ts"

import "./InputGroup.vue?vue&type=style&index=0&id=560000ef&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560000ef"]])

export default __exports__